import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
// import Cookies from 'js-cookie';
import api from '../../api/axios';

const UserProfile = () => {
    const navigate = useNavigate();
    const [user, setUser] = useState({ UserID: '', DisplayName: '', Email: '' });

    const [showStatement, setShowStatement] = useState(false);
    const [clients, setClients] = useState([]);
    const [oldpassword, setOldPassword] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');



    const handlePasswordChange = async () => {
        if (password !== confirmPassword) return alert('Password tidak cocok');
        try {
            const token = localStorage.getItem('token');
            const res = await api.post('cred/chpassw', { 
                oldPassword: oldpassword,
                newPassword: password
              }, {
                headers: { authorization: token },
            });
            console.log('Ganti Password',res.data)
            alert(res.data.responseMessage);
            setPassword('');
            setConfirmPassword('');
        } catch (error) {
            alert('Error changing password:', error);
        }
    };


    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) return navigate('/');




        try {
            const decoded = jwtDecode(token);
            const { UserID, DisplayName, Email } = decoded;
            if (!UserID || !DisplayName) throw new Error('Invalid token data');
            setUser({ UserID, DisplayName, Email });

            // Load additional data (dummy for now)
            setClients([{ id: 1, name: 'PT A' }, { id: 2, name: 'PT B' }]);
        } catch {
            //   Cookies.remove('token');

            navigate('/');
        }

        const fetchCompanies = async () => {

            try {
                // const token = Cookies.get('token');
                const token = localStorage.getItem('token')
                const res = await api.get('cred/cidavailable', {}, {
                    headers: { authorization: token },
                });
                setClients(res.data.data);
            } catch (error) {
                console.error('Error fetching inventory:', error);
            }
        };
        fetchCompanies();


    }, [navigate]);

    return (
        <div className="container mt-4">
            <h3>Hi, {user.DisplayName}</h3>
            <p className="text-body-secondary">Detail profil Anda</p>

            <div className="card mb-4 shadow-sm">
                <div className="card-header">INFORMASI PENGGUNA</div>
                <div className="card-body">
                    <div className="mb-3">
                        <label className="form-label">User ID</label>
                        <input type="text" className="form-control" value={user.UserID} readOnly />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Nama Lengkap</label>
                        <input type="text" className="form-control" value={user.DisplayName} readOnly />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Email</label>
                        <input type="text" className="form-control" value={user.Email || ''} readOnly />
                    </div>
                </div>
            </div>
            {/* Client List */}

            {/* {
			"CompanyName": "Komunika Mitra Pratama",
			"ShortCompName": "KMP",
			"dbname": "kmpima",
			"cid": "22404",
			"cidname": "SINTANG"
		}, */}
            <div className="card mb-3 shadow-sm">
                <div className="card-header">CLUSTER LIST</div>
                <div className="card-body p-2">
                    <table className="table table-bordered table-sm">
                        <thead>
                            <tr>
                                <th>CODE</th>
                                <th>PT</th>
                                <th>Cluster</th>
                            </tr>
                        </thead>
                        <tbody>
                            {clients.map(client => (
                                <tr key={client.cid}>
                                    <td>{client.ShortCompName + '-' + client.cid}</td>
                                    <td>{client.CompanyName}</td>
                                    <td>{client.cidname}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>



            {/* Change Password */}


            {/* Monthly Closing Section */}
            <div className="mb-4 border rounded p-3 shadow-sm alert alert-secondary">
                <div
                    style={{ cursor: 'pointer' }}
                    onClick={() => setShowStatement(!showStatement)}
                    className="d-flex justify-content-between align-items-center"
                >
                    <strong>GANTI PASSWORD</strong>
                    <span>{showStatement ? '▲ Tutup' : '▼ Buka'}</span>
                </div>

                {showStatement && (
                    <div className="mt-3">
                        <div className="card mb-4 shadow-sm">
                            {/* <div className="card-header">Ganti Password</div> */}
                            <div className="card-body">
                            <div className="mb-3">
                                    <label>Password Lama</label>
                                    <input
                                        type="password"
                                        className="form-control"
                                        value={oldpassword}
                                        onChange={(e) => setOldPassword(e.target.value)}
                                    />
                                </div>
                                <div className="mb-3">
                                    <label>Password Baru</label>
                                    <input
                                        type="password"
                                        className="form-control"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                </div>
                                <div className="mb-3">
                                    <label>Konfirmasi Password</label>
                                    <input
                                        type="password"
                                        className="form-control"
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                    />
                                </div>
                                <button className="btn btn-success" onClick={handlePasswordChange}>
                                     Simpan Password
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default UserProfile;
